// Generated by purs version 0.15.0
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ratio from "../Data.Ratio/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var Rational = function (x) {
    return x;
};
var udecodeRational = {
    unsafeDecode: /* #__PURE__ */ (function () {
        var dec = function (v) {
            return Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt)(v.numerator)(v.denominator);
        };
        var $10 = Unscramble.unsafeDecode(Unscramble.decodeRecord1()(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "denominator";
            }
        })(Unscramble.decodeInt1)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "numerator";
            }
        })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))));
        return function ($11) {
            return dec($10($11));
        };
    })()
};
var showRational = /* #__PURE__ */ Data_Ratio.showRatio(Data_Show.showInt);
var semiringRational = /* #__PURE__ */ Data_Ratio.semiringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var ringRational = /* #__PURE__ */ Data_Ratio.ringRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var ordRational = /* #__PURE__ */ Data_Ratio.ordRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var newtypeRational = {
    Coercible0: function () {
        return undefined;
    }
};
var euclideanRingRational = /* #__PURE__ */ Data_Ratio.euclideanRingRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var eqRational = /* #__PURE__ */ Data_Ratio.eqRatio(Data_Eq.eqInt);
var encodeRational = {
    encode: function (v) {
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
            reflectSymbol: function () {
                return "numerator";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode)))({
            reflectSymbol: function () {
                return "denominator";
            }
        })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))({
            numerator: Data_Ratio.numerator(v),
            denominator: Data_Ratio.denominator(v)
        });
    }
};
var divisionRingRational = /* #__PURE__ */ Data_Ratio.divisionRingRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
var decodeRational = {
    decode: /* #__PURE__ */ (function () {
        var dec = function (v) {
            return Data_Ratio.reduce(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt)(v.numerator)(v.denominator);
        };
        var $12 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(dec);
        var $13 = Foreign_Generic_Class.decode(Foreign_Generic_Class.recordDecode()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "numerator";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())({
            reflectSymbol: function () {
                return "denominator";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))()));
        return function ($14) {
            return $12($13($14));
        };
    })()
};
var commutativeRingRational = /* #__PURE__ */ Data_Ratio.commutativeRingRatio(Data_Ord.ordInt)(Data_EuclideanRing.euclideanRingInt);
export {
    Rational,
    newtypeRational,
    eqRational,
    ordRational,
    showRational,
    semiringRational,
    ringRational,
    commutativeRingRational,
    euclideanRingRational,
    divisionRingRational,
    encodeRational,
    decodeRational,
    udecodeRational
};
//# sourceMappingURL=index.js.map
